export const blockersConstants = {
    errors: {
        fetchFailed: "Failed to load blockers.",
        analyticsFailed: "Failed to load blockers analytics.",
        fetchDetailFailed: "Failed to load blocker details.",
        createFailed: "Failed to create blocker.",
        updateFailed: "Failed to update blocker.",
        resolveFailed: "Failed to resolve blocker.",
        escalateFailed: "Failed to escalate blocker.",
        linkTasksFailed: "Failed to link tasks.",
        unlinkTaskFailed: "Failed to unlink task.",
        deleteFailed: "Failed to delete blocker.",
        genericError: "Something went wrong.",
    },
    messages: {
        createSuccess: "Blocker created successfully.",
        updateSuccess: "Blocker updated successfully.",
        deleteSuccess: "Blocker deleted successfully.",
        resolveSuccess: "Blocker marked as resolved.",
        escalateSuccess: "Blocker escalated.",
        linkTasksSuccess: "Tasks linked successfully.",
        unlinkTaskSuccess: "Task unlinked.",
    },
};
